import { useState } from "react";
import { login as loginApi } from "./AuthService";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function Login(){

  const nav = useNavigate();
  const { login } = useAuth();
  const [username,setUsername] = useState("");
  const [password,setPassword] = useState("");
  const [error,setError] = useState("");

  const submit = async (e)=>{
    e.preventDefault();
    try{
      const data = await loginApi(username,password);

      if(!data?.token) throw new Error("Invalid login");

      login({
        userId: data.userId,
        username: data.username,
        token: data.token
      });

      nav("/today");

    }catch(err){
      setError("Invalid username or password");
    }
  };

  return (
    <div style={{
      height:"100vh",
      display:"flex",
      justifyContent:"center",
      alignItems:"center"
    }}>
      <div className="card" style={{ width:"380px" }}>

        <div style={{ textAlign:"center", marginBottom:"15px" }}>
          <h2>Welcome Back</h2>
          <p style={{ color:"#6b7280" }}>Login to your account</p>
        </div>

        <form onSubmit={submit} className="form-grid" style={{ gridTemplateColumns:"1fr" }}>

          <input className="input"
            placeholder="Username"
            onChange={e=>setUsername(e.target.value)}
            required
          />

          <input className="input"
            type="password"
            placeholder="Password"
            onChange={e=>setPassword(e.target.value)}
            required
          />

          {error && (
            <div style={{ color:"#ef4444", fontSize:"14px" }}>{error}</div>
          )}

          <button className="btn btn-primary" type="submit">Login</button>
        </form>

        <div style={{ textAlign:"center", marginTop:"15px" }}>
          <p
            onClick={()=>nav("/forgot-password")}
            style={{ cursor:"pointer", color:"#6366f1", fontSize:"14px" }}
          >
            Forgot password?
          </p>

          <p style={{ fontSize:"14px", color:"#6b7280" }}>
            Don’t have an account?{" "}
            <span
              style={{ color:"#6366f1", cursor:"pointer" }}
              onClick={()=>nav("/signup")}
            >
              Sign up
            </span>
          </p>
        </div>

      </div>
    </div>
  );
}
